export const data = () => ({
  isDebug: true,
  loading: false,
  communicationID: 0,
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
